@if (isOpen()) {
  <div class="dropdown" [style]="style()" (click)="$event.stopPropagation()">
    @for (action of actions(); track action.name) {
      <div class="action" (click)="onClickAction(action)">
        <div class="icon" [title]="action.text | translate">
          <i class="fal fa-{{ action.icon }}"></i>
        </div>
        <div class="text">{{ action.text | translate }}</div>
      </div>
    }
  </div>
}
